import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { INITIAL_LOGIN_METHOD } from "@utils/constants";
export const baseUrl = process.env.API_BASE;

const customBaseQuery = async (args, api, extraOptions) => {
  const baseResult = await fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      if (!headers.has("content-type")) {
        headers.set("content-type", "application/json");
      } else {
        headers.delete("content-type");
      }
      const token = getState().auth.token;

      if (token) {
        headers.set("authorization", token);
      }
      return headers;
    },
    timeout: 10000,
  })(args, api, extraOptions);

  // Session expire code then redirect to login
  if (baseResult.meta?.response?.status === 403) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(`/login`);
  }

  return baseResult;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({}),
});
